import { Program } from 'modules/program';

import { AbritelPrograms } from './config/abritel-program.config';
import { BookabachPrograms } from './config/bookabach-program.config';
import { ExpediaPrograms } from './config/expedia-program.config';
import { FewoDirektPrograms } from './config/fewo-direkt-program.config';
import { HotelsPrograms } from './config/hotels-program.config';
import { StayzPrograms } from './config/stayz-program.config';
import { VrboPrograms } from './config/vrbo-program.config';
import { WotifPrograms } from './config/wotif-program.config';

const Programs: Record<string, Program> = {
  ...AbritelPrograms,
  ...BookabachPrograms,
  ...ExpediaPrograms,
  ...FewoDirektPrograms,
  ...HotelsPrograms,
  ...StayzPrograms,
  ...VrboPrograms,
  ...WotifPrograms,
};

export { Programs };
